export default "__VITE_ASSET__BnS6_RxZ__"